import LuxuryInsightsSection from "../components/AgentsPage/LuxuryInsightsSection";
import AgentsSection from "../components/Homepage/AgentsSection";
import Framework from "../components/Homepage/Framework";
import LetsTalkLuxurySection from "../components/Homepage/LetsTalkLuxurySection";
import LuxurySection from "../components/Homepage/LuxurySection";
import TestimonialsSection from "../components/Homepage/TestimonialsSection";
import BenefitsAgent from "../components/Sections/benefitsAgent";
import HeroExperienceSection from "../components/Sections/HeroExperienceSection";
import { MessageSquareHeart, ClipboardCheck, BrainCircuit, Megaphone,Lightbulb } from "lucide-react";
import { Diamond, Brain, Sparkles } from "lucide-react";


 const agentBenefits = [
    {
      id: 1,
      icon: MessageSquareHeart,
      title: "Emotional Intelligence",
      text: "Understands emotion and intent in real-time communication.",
    },
    {
      id: 2,
      icon: ClipboardCheck,
      title: "Operational Ease",
      text: "Manages bookings, inquiries, and service requests seamlessly.",
    },
    {
      id: 3,
      icon: BrainCircuit,
      title: "Predictive Empathy",
      text: "Learns from guest behavior to anticipate and fulfill future needs.",
    },
    {
      id: 4,
      icon: Megaphone,
      title: "Brand Voice",
      text: "Speaks in your brand’s tone — refined, human, and distinct.",
    },
  ];
  const insightsData = {
    badge: <Lightbulb size={18} color="#00ffff" />,
    badgeLabel:"Why They Matter",
    leftTitle: "Luxury is in the Details",
    leftText:
      "AI Squared Agents handle the unseen details — from instant messages to smart dashboards — freeing your team to focus on what defines true luxury: the human touch.",
    rightText:
      "True luxury isn’t loud — it’s felt in the perfection of every moment.",
    steps: [
      {
        id: 1,
        icon: Diamond,
        title: "Intelligent Efficiency",
        text: "AI Squared Agents streamline operations — from WhatsApp inquiries to dashboard insights — reducing workload while increasing precision.",
        first: true,

      },
      {
        id: 2,
        title: "Consistent Brilliance",
        text: "They ensure your brand’s tone, warmth, and elegance never waver — every interaction feels authentically you.",
        icon: Brain,
        middle: true,

      },
      {
        id: 3,
        title: "Data that Refines Luxury",
        text: "Each conversation becomes insight. AI Squared transforms guest behavior into actionable data that strengthens loyalty, personalization, and brand reputation.",
        curved: true,
        icon: Sparkles,
      },
      
    ],
  };
export default function AgentsPage() {
  return (
    <>
<HeroExperienceSection
  title="Where <span>Intelligence</span><br/>Meets Experience"
  subtitle="At <strong>AI Squared</strong>, we redefine what it means to deliver hospitality through technology.<br/><br/>Our Agents don’t just automate — they understand, anticipate, and elevate every guest interaction, blending data with emotion to create experiences that feel effortlessly personal and luxuriously human."
  primaryBtn={{ label: "Explore Agents", link: "/agents" }}
  secondaryBtn={{ label: "Book a Demo", link: "/hotel" }}
  cards={[
    {
      title: "3 Core Agents",
      subtitle: "Hotel · Restaurant · Clinic",
      description: "Each designed for precision and empathy.",
    },
    {
      title: "1,200+",
      subtitle: "Active Interactions Weekly",
      description: "Every message refined into an experience.",
    },
    {
      title: "99.4% ↑",
      subtitle: "Response Accuracy",
      description:
        "AI Squared Agents understand tone, timing, and intent instantly.",
    },
    {
      title: "Guests · Managers · Concierge AI",
      description: "Effortless connection between humans and AI.",
    },
  ]}
/>
<BenefitsAgent
      title="What Are AI Squared Agents?"
      subtitle="AI Squared Agents mirror your brand’s personality — precise, empathetic, and effortless. They understand, adapt, and respond with intention, ensuring every guest feels remembered, not managed."
      tagline="They Understand, Anticipate, and Deliver:"
      items={agentBenefits}
    />
        <LuxurySection/>
    <AgentsSection/>
 <LuxuryInsightsSection
        badge={insightsData.badge}
        badgeLabel={insightsData.badgeLabel}
        leftTitle={insightsData.leftTitle}
        leftText={insightsData.leftText}
        rightText={insightsData.rightText}
        steps={insightsData.steps}
      />
            <Framework/>
      <TestimonialsSection/>
      <LetsTalkLuxurySection/>

    </>
  );
}
